import { Duration, Timestamp } from '@bufbuild/protobuf';
import {
  createMsgRevokeGenericAuthorization,
  generateTypes,
  MSG_REVOKE_GENERIC_AUTHORIZATION_TYPES,
} from '@evmos/eip712';
import { createMsgRevoke } from '@evmos/proto';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';

export interface MsgGenericRevokeParams {
  granteeAddress: string;
  typeUrl: string;
}

export const createTxMsgRevokeGenericGrant = (
  context: TxContext,
  params: MsgGenericRevokeParams | MsgGenericRevokeParams[],
): TxPayload => {
  const typedData = createEIP712MsgRevokeGenericGrant(context, params);
  const cosmosMsg = createCosmosMsgRevokeGenericGrant(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgRevokeGenericGrant = (
  context: TxContext,
  params: MsgGenericRevokeParams | MsgGenericRevokeParams[],
): EIP712TypedData => {
  const types = generateTypes(MSG_REVOKE_GENERIC_AUTHORIZATION_TYPES);
  const messages = (Array.isArray(params) ? params : [ params ]).map((params) =>
    createMsgRevokeGenericAuthorization(context.sender.accountAddress, params.granteeAddress, params.typeUrl));
  return { types, message: messages.length === 1 ? messages[0] : messages };
};

const createCosmosMsgRevokeGenericGrant = (
  context: TxContext,
  params: MsgGenericRevokeParams | MsgGenericRevokeParams[],
) => {
  return (Array.isArray(params) ? params : [ params ]).map((params) =>
    createMsgRevoke(context.sender.accountAddress, params.granteeAddress, params.typeUrl));
};

